import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TProductInstance } from '@lib/core/products/types';
import { getProductsListData } from '@lib/core/products/utils';
import { ApiQueries } from '@lib/core/service/consts';
import { createTypedAsyncThunk } from '@lib/core/service/createTypedAsyncThunk';
import { parseError } from '@lib/core/service/requests/parseError';

interface IState {
  currentDiscoveryQuizProductInstance: TProductInstance;
  discoveryQuizProductInstances: TProductInstance[];
  isDiscoveryQuizProductInstancesLoading: boolean;
}

const initialState: IState = {
  currentDiscoveryQuizProductInstance: undefined,
  discoveryQuizProductInstances: undefined,
  isDiscoveryQuizProductInstancesLoading: false,
};

export const fetchDiscoveryQuizProductInstances = createTypedAsyncThunk(
  'fetchDiscoveryQuizProductInstances',
  async (productInstanceData: TProductInstance) => {
    try {
      const productCategory = productInstanceData?.product?.category;

      const { results: products = [] } = await getProductsListData({
        [ApiQueries.productCategory]: productCategory,
        offset: 0,
      });

      return products;
    } catch (error) {
      return Promise.reject(parseError(error));
    }
  },
);

const discoveryQuizSlice = createSlice({
  extraReducers: builder => {
    builder
      .addCase(fetchDiscoveryQuizProductInstances.pending, state => {
        state.discoveryQuizProductInstances = undefined;
        state.isDiscoveryQuizProductInstancesLoading = true;
      })
      .addCase(fetchDiscoveryQuizProductInstances.fulfilled, (state, action) => {
        state.discoveryQuizProductInstances = action.payload;
        state.isDiscoveryQuizProductInstancesLoading = false;
      })
      .addCase(fetchDiscoveryQuizProductInstances.rejected, state => {
        state.discoveryQuizProductInstances = undefined;
        state.isDiscoveryQuizProductInstancesLoading = false;
      });
  },
  initialState,
  name: 'discoveryQuiz',
  reducers: {
    setCurrentDiscoveryQuizProductInstance: (state, action: PayloadAction<TProductInstance>) => {
      state.currentDiscoveryQuizProductInstance = action.payload;
    },
  },
});

export const { setCurrentDiscoveryQuizProductInstance } = discoveryQuizSlice.actions;

export default discoveryQuizSlice.reducer;
